module.exports = __webpack_public_path__ + "assets/img/stateRun.dd5af47c.png";